const PROPOSAL_MANAGEMENT_STATUS_COLORS = {
    Elaboração: "yellow",
    Ativa: "yellow",
    Liberada: "green",
    PedidoGerado: "green",
    Negociação: "purple",
    NegociaçãoSemestre: "purple",
    Cancelada: "red",
    Substituida: "black",
    Aprovada: "blue",
    EspecificaçãoBIM: "green",
    Concorrência: "yellow",
    Parada: "yellow",
}

const getProposalManagementStatusColor = (status, orderGenerated = false) => {
    if (status === "Aprovada") return "blue"
    if (status === "Cancelada") return "red"
    if (status === "Substituida") return "black"

    if (
        orderGenerated ||
        status === "Liberada" ||
        status === "PedidoGerado"
    ) {
        return "green"
    }

    return PROPOSAL_MANAGEMENT_STATUS_COLORS[status] || "yellow"
}

export {
    PROPOSAL_MANAGEMENT_STATUS_COLORS,
    getProposalManagementStatusColor,
}
